export const GET_TRANSIT_LOG = "GET_TRANSIT_LOG";
export const SET_MAP_POINT_LIST = "SET_MAP_POINT_LIST";
export const SET_TRANSIT_LOG_LOADING_STATUS = 'SET_TRANSIT_LOG_LOADING_STATUS'